import Page from 'classes/Page'

export default class BookingSearch extends Page {
    constructor () {
        super({
            id: 'bookingSearch',
            element: '.bookingSearch',
            elements: {
                //header: document.querySelector('.header'),
            }
        })

        this.checkInDate;
        this.checkOutDate;

        this.bookAccommodation = document.querySelector('.mphb-book-button');
        this.closeBookingCartButton = document.querySelector('.closeBookingCart');
        this.checkOutButton = document.querySelector('.checkout_button');

        /** Check if is page **/
        if (document.getElementsByClassName(this.id).length > 0) {
            this.createInteractions();
            this.addToBookingCart();
            this.addBookingInfo();
            this.addIDtoEachRemoveButton();
        }

    }

    addIDtoEachRemoveButton(){
        var $ = jQuery;
        $('.mphb-room-type').each(function(i, obj) {
            let id = $(this).find('.mphb-reserve-room-section').attr('data-room-type-id');
            $(this).find('.mphb-remove-from-reservation').attr('data-room-type-id',id);

            $(this).find('.mphb-reserve-room-section').addClass('room-section-wrapper-'+id);
        });
    }

    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    addBookingInfo(){

        /*** Booking Cookies Checker ***/
        const BookingCheckInDate = this.getCookie('BookingCheckInDate');
        this.checkInDate = BookingCheckInDate;
        const BookingCheckOutDate = this.getCookie('BookingCheckOutDate');
        this.checkOutDate = BookingCheckOutDate;
        const BookingAdults = this.getCookie('BookingAdults');
        const BookingChildren02 = parseInt(this.getCookie('BookingChildren02'));
        const BookingChildren216 = parseInt(this.getCookie('BookingChildren216'));


        var bookingInfo = document.getElementsByClassName('mphb_sc_search_results-info')[0];

        var checkIfRooms = document.getElementsByClassName('mphb-room-type')[0];

        if(checkIfRooms){
            // Available Accomoodations was found
            bookingInfo.innerHTML = "";


            bookingInfo.innerHTML += `<div class="bookingInfo"></div>`;

            if(BookingCheckInDate && BookingCheckOutDate){
                var nightsText = this.getNightsText(this.calculateNrNights());
                var reservationText = nightsText[0];
                var nrNightsText = nightsText[1];
                bookingInfo.innerHTML += `<div>
                                            <div class="bookingInfoTitle">`+reservationText+`</div>
                                            <div>
                                                `+this.calculateNrNights()+` `+nrNightsText+`
                                                (`+this.checkInDate+` - `+this.checkOutDate+ `)
                                            </div>`;
            }

            if(BookingAdults){
                if(currentSiteLang == 'pt-pt'){
                    var title = "Adultos";
                }
                else{
                    var title = "Adults";
                }
                bookingInfo.innerHTML += "<div>"+title+" - "+BookingAdults+"</div>";
            }

            if(BookingChildren02 > 0){
                if(currentSiteLang == 'pt-pt'){
                    var title = "Crianças (0 a 2 anos)";
                }
                else{
                    var title = "Children (0 to 2 years)";
                }
                bookingInfo.innerHTML += "<div>"+title+" - "+BookingChildren02+"</div>";
            }

            if(BookingChildren216 > 0){
                if(currentSiteLang == 'pt-pt'){
                    var title = "Crianças (2 a 16 anos)";
                }
                else{
                    var title = "Children (2 to 16 years)";
                }
                bookingInfo.innerHTML += "<div>"+title+" - "+BookingChildren216+"</div>";
            }

            bookingInfo.innerHTML += "</div>";
        }
        else{
            // No accomodations was found
            var headerReserveButton = document.getElementById('headerReserveButton');
            headerReserveButton.style.display = "block";

            var checkoutButton = document.getElementById('checkoutButton');
            checkoutButton.style.display = "none";


            const infoBB = document.getElementById('bookingAccommodations');

            if(currentSiteLang == 'pt-pt'){
                infoBB.innerHTML = `<div>
                                        <h5 style="margin-top: 40px; margin-bottom: 20px;">Não foram encontrados alojamentos para estas datas.</h5>
                                        <h6>Por favor, tente novamente com datas diferentes.</h6>
                                        <a id="searchDatesAgain">
                                            Mudar as datas
                                        </a>
                                    </div>`;
            }
            else{
                infoBB.innerHTML = `<div>
                                        <h5 style="margin-top: 40px; margin-bottom: 20px;">No Available Accommodations was found for this dates.</h5>
                                        <h6>Please try again with different dates.</h6>
                                        <a id="searchDatesAgain">
                                            Change Dates
                                        </a>

                                    </div>`;
            }

            jQuery( "#searchDatesAgain" ).on( "click", function() {

                jQuery('.menu_button').css('opacity','0');
                jQuery('.menu_button').css('visibility','hidden');

                jQuery('.header').addClass('availability_open');


                jQuery('.availability ').removeClass('availability_hidden');
                jQuery('.availability ').addClass('availability_visible');
                jQuery('.availability ').css('opacity','1');
                jQuery('.availability').css('visibility','visible');
                jQuery('.availability').css({"-webkit-transform":"translate(0,0)"});

                jQuery('.bookingCalendar').show();
                jQuery('.bookingCalendar ').css('opacity','1');
                jQuery('.bookingCalendar').css('visibility','visible');
                jQuery('.bookingCalendar').css({"-webkit-transform":"translateY(10px)"});

                jQuery('.bookingCalendar_wrapper').css('opacity','1');
                //transform: translate(0px, 0px); opacity: 1; visibility: inherit;
            });

        }

    }

    closeBookingCart = () => {
        const el = document.querySelector('#bookingCart');
        el.classList.remove("visible");
    }

    getNightsText(nrNights) {
        if(currentSiteLang == 'pt-pt'){
            var reservationText = 'Reserva para';
            if(nrNights < 2){
                var nrNightsText = "noite";
            }
            else{
                var nrNightsText = "noites";
            }
        }
        else{
            var reservationText = 'Reservation for';
            if(nrNights < 2){
                var nrNightsText = "night";
            }
            else{
                var nrNightsText = "nights";
            }
        }

        return [reservationText,nrNightsText];
    }

    calculateNrNights(){
        var checkIn = new Date(this.checkInDate.split("/").reverse().join("-"));
        var checkOut = new Date(this.checkOutDate.split("/").reverse().join("-"));

        var difference = checkOut.getTime() - checkIn.getTime();
        var nrNights = Math.ceil(difference / (1000 * 3600 * 24));

        return nrNights;
    }

    addToBookingCart() {
        var $ = jQuery;
        var that = this;

        $( ".mphb-book-button,.mphb-remove-from-reservation" ).on( "click", function() {
            setTimeout(() => {
                that.bookingCartContent();
            }, "500")
        });

    }

    toggleBookingCart = () => {
        var $ = jQuery;
        var that = this;

        const el = document.querySelector('#bookingCart');

        var hasAccommodations = false;
        $('.mphb-room-type').each(function(i, obj) {
            if($(obj).find('.mphb-reserve-room-section').hasClass('mphb-rooms-added')){
                hasAccommodations = true;
                return '';
            }
        });

        if(!hasAccommodations){
            $('#bookingCart .bookingCartInner').html('');
            that.noAccommodationsInCart();
        }

        el.classList.toggle("visible");
    }

    noAccommodationsInCart(){
        /** No Accommodations In Cart **/
        var $ = jQuery;
        var that = this;

        if(currentSiteLang == 'pt-pt'){
            var text = "Sem alojamentos no carrinho";
        }
        else{
            var text = "No Accomodations in Cart";
        }

        $('#bookingCart .bookingCartInner').append(`<div class="noAccommodationsOnCart">`+text+`</div>`);
        $('#bookingCartForm').append('<div class="closeBookingCart2 withText">'+text+'</div>');

        /** Add Check In and Checkout Dates **/
        var nightsText = that.getNightsText(that.calculateNrNights());
        var reservationText = nightsText[0];
        var nrNightsText = nightsText[1];

        $( "#bookingCart .bookingCartInner" ).prepend(`<div class="datesInfo">
            <div>`+reservationText+` `+that.calculateNrNights()+` `+nrNightsText+` (`+that.checkInDate+` - `+that.checkInDate+ `)</div>
        </div>`);

        if(currentSiteLang == 'pt-pt'){
            var text = "Fechar";
        }
        else{
            var text = "Close";
        }

        $('#bookingCart .bookingCartInner').append('<div class="closeBookingCart2 withText">'+text+'</div>');



        $( ".closeBookingCart2" ).click(function() {
            const el = document.querySelector('#bookingCart');
            el.classList.remove("visible");
        });
    }

    bookingCartContent(){
        var $ = jQuery;
        var that = this;

        $('#bookingCart .bookingCartInner').html('');
        $('#bookingCart').removeClass('visible');
        $('#bookingCart').addClass('visible');

        var hasAccommodations = false;
        $('.mphb-room-type').each(function(i, obj) {
            if($(obj).find('.mphb-reserve-room-section').hasClass('mphb-rooms-added')){
                hasAccommodations = true;
                return '';
            }
        });

        if(hasAccommodations){

            $('#bookingCart .bookingCartInner').append($('.mphb-cart-message').clone());


            $('.mphb-room-type').each(function(i, obj) {
                if($(obj).find('.mphb-reserve-room-section').hasClass('mphb-rooms-added')){
                    $("#bookingCart .bookingCartInner").append($(obj).clone());
                    hasAccommodations = true;
                }
            });

            /** Remove quantity changer, click inside booking cart wont work **/
            $(`#bookingCart .mphb-rooms-quantity-wrapper,
            #bookingCart .mphb-book-button,
            #bookingCart .mphb-confirm-reservation
            `).remove();

            /** Add to Bottom Total **/
            $('#bookingCart .bookingCartInner').append('<div id="bookingCartForm"></div>');
            $('#bookingCartForm').append($('#mphb-reservation-cart').clone());

            /** Add foreach room in cart, number of selected **/

            // if(currentSiteLang == 'pt-pt'){
            //     $('#bookingCart .mphb-book-button').html('Alterar');
            //     $('#bookingCart .mphb-remove-from-reservation').html('<span>X</span> Remover');
            // }
            // else{
            //     $('#bookingCart .mphb-book-button').html('Change');
            //     $('#bookingCart .mphb-remove-from-reservation').html('<span>X</span> Remove');
            // }

            //$('#bookingCart').append($('.mphb_sc_search_results-wrapper').clone());

            /** Add number books accommodations **/
            $(`#bookingCart .bookingCartInner input[name^='mphb_rooms_details'`).each(function(i, obj) {
                var nrBooked = $(this).val();
                var name = $($(this)).attr("name");
                var getName = name.match(/\[(.*?)\]/);
                var id = getName[1];

                if(currentSiteLang == 'pt-pt'){
                    var text = "Quantidade Seleccionada";
                }
                else{
                    var text = "Amount Selected";
                }

                //$('.bookingCart .post-'+id+' .rightCol').append(`<div class="nrBooked">`+text+`: <span>`+nrBooked+`</span></div>`);

                $(`<div class="nrBooked">`+text+`: <span>`+nrBooked+`</span></div>`).insertBefore('#bookingCart .post-'+id+' .rightCol .mphb-regular-price');
            });

            if(currentSiteLang == 'pt-pt'){
                var text = "Fechar";
            }
            else{
                var text = "Close";
            }

            $('#bookingCartForm').append('<div class="closeBookingCart2 withText">'+text+'</div>');

            /** Add Check In and Checkout Dates **/
            var nightsText = that.getNightsText(that.calculateNrNights());
            var reservationText = nightsText[0];
            var nrNightsText = nightsText[1];

            $( "#bookingCart .bookingCartInner" ).prepend(`<div class="datesInfo">
                <div>`+reservationText+` `+that.calculateNrNights()+` `+nrNightsText+` (`+that.checkInDate+` - `+that.checkInDate+ `)</div>
            </div>`);

            $( ".closeBookingCart2" ).click(function() {
                const el = document.querySelector('#bookingCart');
                el.classList.remove("visible");
            });


            $('#bookingCart .mphb-remove-from-reservation').click(function() {
                let id = $(this).attr('data-room-type-id');
                $('#mphb-rooms-quantity-'+id).val(1);
                $('.room-section-wrapper-'+id).removeClass('mphb-rooms-added');
                /** Appended remove accommodation remove button click wont trigger, force it in content button **/
                $('.mphb_sc_search_results-wrapper .mphb-room-type.post-'+id+' .mphb-remove-from-reservation').trigger('click');
                that.bookingCartContent();

            });
        }
        else{
            that.noAccommodationsInCart();
        }
    }

    // addToBookingCart2 = () => {

    //     var bookingCart = document.getElementById('bookingCart');
    //     bookingCart.innerHTML = "";

    //     setTimeout(() => {

    //         var bookingAccommodations = document.getElementsByClassName('mphb_sc_search_results-wrapper');
    //         var bookingAccommodationsClone = bookingAccommodations[0].cloneNode(true);
    //         bookingCart.appendChild(bookingAccommodationsClone);

    //         var bookingInfo = document.getElementById('mphb-reservation-cart');
    //         var bookingInfoClone = bookingInfo.cloneNode(true);
    //         bookingCart.appendChild(bookingInfoClone);


    //         /** In booking Cart, if accomodation is not added, remove it **/
    //         var els = document.getElementsByClassName("bookingCart")[0].getElementsByClassName("mphb-room-type");
    //         for(var i = 0; i < els.length; i++) {
    //             console.log(els[i]);
    //             if (els[i].getElementsByClassName('mphb-rooms-added').length == 0) {
    //                 els[i].style.visibility = "hidden";
    //                 els[i].style.display = "none";
    //             }
    //         }

    //         //bookingCart.innerHTML = bookingInfo.innerHTML;

    //         // var checkIn = document.getElementsByName("mphb_check_in_date")[0].value;
    //         // var checkOut = document.getElementsByName("mphb_check_out_date")[0].value;
    //         // console.log(checkIn,checkOut);
    //       }, "1000")

    // }

    createInteractions = () => {
        //this.bookAccommodation.addEventListener('click', this.addToBookingCart2);
        this.closeBookingCartButton.addEventListener('click', this.closeBookingCart);
        this.checkOutButton.addEventListener('click', this.toggleBookingCart);
    }

}
